import {useContext, useEffect, useRef, useState} from "react";
import CompanyHeader from "./CompanyHeader";
import DesktopNavigation from "./DesktopNavigation";
import MobileFilterBar from "../MobileFilterMenu/MobileFilterBar";
import {MobileMenuState, PwaContext} from "../providers/PwaContext";
import MobileMenu from "../MobileMenu";
import TopHeader from "./TopHeader";

export default function SiteHeader({
	                                   color,
	                                   headerNotTransparent,
	                                   showFilterBar,
									   hasShadow
                                   }: {
	color?: string;
	headerNotTransparent?: boolean;
	showFilterBar?: boolean;
	hasShadow?: boolean;
}) {
	const [openedMobileMainMenu, setOpenedMobileMainMenu] = useState(false);
	const [openedMobileFilterMenu, setOpenedMobileFilterMenu] = useState(false);
	const [hasScrolledDown, setHasScrolledDown] = useState(false);
	useEffect(() => {
		window.onscroll = function () {
			scrollFunction();
		};
		window.onresize = function () {
			setNavHeight(ref.current ? ref.current.clientHeight - 1 : 0);
		};
		setNavHeight(ref.current ? ref.current.clientHeight - 1 : 0);
	}, []);

	// useEffect(() => {
	//   setNavHeight(ref.current ? ref.current.clientHeight - 1 : 0);
	// }, [router.asPath]);

	function scrollFunction() {
		if (
			document.body.scrollTop > 50 ||
			document.documentElement.scrollTop > 50
		) {
			setHasScrolledDown(true);
		} else {
			setHasScrolledDown(false);
		}
	}

	const {mobileMenuState, setMobileMenuState} = useContext(PwaContext);
	const ref = useRef<HTMLDivElement | null>(null);
	const [navHeight, setNavHeight] = useState(100);
	useEffect(() => {
		setNavHeight(ref.current ? ref.current.clientHeight - 1 : 0);
	}, [ref]);

	return (
		<>
			<div
				style={{height: navHeight}}
				className={`${!headerNotTransparent ? "hidden" : ""}`}
			></div>
			<div
				id="header"
				className="fixed w-screen top-0 z-20"
				ref={ref}
			>
				<TopHeader 
					color={color}
				/>
				<CompanyHeader
					color={color}
					scrolledStyle={!headerNotTransparent ? hasScrolledDown : true}
					onToggleMobileMenu={setOpenedMobileMainMenu}
					open={openedMobileMainMenu}
					headerNotTransparent={headerNotTransparent}
					hasScrolledDown={hasScrolledDown}
					hasShadow={hasShadow}
				/>
				{showFilterBar && !openedMobileMainMenu && (
					<MobileFilterBar
						onOpenFilterMenu={() => {
							setMobileMenuState(MobileMenuState.FILTER);
							return;
						}}
					/>
				)}
			</div>
			<MobileMenu
				open={openedMobileMainMenu}
				onClose={() => setOpenedMobileMainMenu(false)}
			/>
		</>
	);
}
